/*
 * @Author: libo 
 * @Date: 2020-11-13 17:44:09 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-06 19:14:58
 */

<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
        <a-button key="close" @click="handleCancel">
          {{ $t('关闭') }}
        </a-button>
        <a-popconfirm :title="$t('确定修改吗?')" @confirm="() => handleOk()" v-if="!disableSubmit">
          <a-button type="primary" key="ok">{{ $t('确定') }}</a-button>
        </a-popconfirm>
    </template>
    <a-spin :spinning="confirmLoading">
      <detail-list v-if="title == $t('详情')">
        <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
        <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
        <detail-list-item :term="$t('手机号码')">{{model.userPhone}}</detail-list-item>
        <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
        <detail-list-item :term="$t('日冻结用量(m³)')">{{model.dayUse}}</detail-list-item>
        <!--<detail-list-item term="上报月份">{{model.reportMonth}}</detail-list-item>-->
        <detail-list-item :term="$t('报表日期')">{{model.reportDate}}</detail-list-item>
      </detail-list>
          <!-- <div>
            <a-tabs v-model="tabKey" @change="changeTab">
              </a-tab-pane>
              <a-tab-pane key="2" tab="图表展示" force-render>
                <Echart ref="option" :options="option" style="height: 100%;min-height: 400px"></Echart>
              </a-tab-pane>
            </a-tabs>
          </div>  -->
      <j-form-container :disabled="formDisabled" v-if="title == $t('编辑')">
        <a-form :form="form" slot="detail">
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item :label="$t('用户编号')">
                <a-input v-model="model.userId" :placeholder="$t('请输入用户编号')" disabled></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('用户名称')">
                <a-input v-model="model.userName" :placeholder="$t('请输入用户编号')" disabled></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('手机号码')">
                <a-input v-model="model.userPhone" :placeholder="$t('请输入用户编号')" disabled></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('表编号')">
                <a-input v-model="model.meterId" :placeholder="$t('请输入表编号')" disabled></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('报表日期')">
                <a-input :placeholder="$t('请选择报表日期')" v-model="model.reportDate" disabled/>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item :label="$t('日冻结用量(m³)')">
                <a-input-number v-model="model.dayUse" :placeholder="$t('请输入日冻结用量')" min='0' style="width: 100%"/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import { httpAction, getAction,putAction } from '@/api/manage'
  import { validateDuplicateValue,listSize } from '@/utils/util'
  import {isUndefined} from'@/utils/validate'
  import DetailList from '@/components/tools/DetailList'
  import echarts from 'echarts/lib/echarts';
  import moment from 'moment'
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterUserWaterReportMonthModal',
    components: {
      DetailList,
      DetailListItem,
    },
    data () {
      return {
        list: [],
        width: 1000,
        title: this.$t('操作'),
        visible: false,
        disableSubmit:false,
        model: {},
        filters: {},
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        confirmLoading: false,
        option: {},
        tabKey: '2',
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          // edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          doPayTask:"/jeecg-charge/meter/userPay/doPayTask",
          UserRecordList:"/jeecg-charge/meter/meterUserWaterReportDay/list", //详情查询接口
          edit: "/jeecg-charge/meter/meterUserWaterReportDay/edit"
        }
      }
    },
    created () {
    },
    computed: {
      // i18n：列定义使用 computed 以响应语言切换
      columns() {
        return [
        {
          title: this.$t('用户编号'),
          dataIndex: 'userId',
          align:"center",
        },
        {
          title: this.$t('表编号'),
          dataIndex: 'meterId',
          align:"center",
        },
        {
          title: this.$t('用户姓名'),
          dataIndex: 'userName',
          align:"center",
        },
        {
          title: this.$t('电话号码'),
          dataIndex: 'userPhone',
          align:"center",
        },
        {
          title: this.$t('用户地址'),
          dataIndex: 'userAddr',
          align:"center",
        },
        {
          title: this.$t('日用量(m³)'),
          dataIndex: 'dayUse',
          align:"center",
        },
        {
          title: this.$t('表口径'),
          dataIndex: 'mtCaliber',
          align:"center",
          customRender: (text,row) => {
            return 'DN'+text;
          }
        },
        {
          title: this.$t('上报月份'),
          dataIndex: 'reportMonth',
          align:"center",
        },
        {
          title: this.$t('报表日期'),
          dataIndex: 'reportDate',
          align:"center",
        },
        ]
      },
    },
    methods: {
      
    handleOk(e) {
      console.log(e);
      
      putAction(this.url.edit,this.model).then(res=>{
        if(res.success){
          this.$message.success(res.message || this.$t('编辑成功'));
          this.visible = false;
          this.$emit('ok');
        }else{
          this.$message.error(res.message)
        }
      });
    },
      handleTableChange(pagination, filters, sorter) {
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.queryUserRecordList();
      },
      queryUserRecordList() {  //详情
        let params = {}
        params.pageNo = this.ipagination.current;
        params.pageSize = this.ipagination.pageSize;
        console.log(this.model);
        params.meterId = this.model.meterId;
        params.beginDate = this.model.reportMonth + "01";
        params.endDate = this.model.reportMonth + "31";
        getAction(this.url.UserRecordList, params).then((res) => {
          if(res.success){
            this.list = res.result.records;
            this.ipagination.total = res.result.total;
          }
        })
      },
      edit (record) { 
        this.model = Object.assign({}, record);
        this.visible = true;
       console.log(this.model.reportMonth);
        this.$nextTick(() => {
        // this.form.setFieldsValue(pick(this.model,))
        })
        //this.queryUserRecordList();
        this.changeTab(2)
      },
      close () {
        this.$emit('close');
        this.disableSubmit = false;
        this.tabKey = '2'
        this.option = {}
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      changeTab(e) {
        if(e==2){
          let categoryData = []
          let seriesData = []
          for(let i=0;i<24;i++) {
            categoryData.push(('00'+i).substr(-2)+':00')
          }
          seriesData = [1,0,0,0,0,0,1.5,2,3,0.2,0.2,3.4,2.6,4.1,1,1.1,0.5,0.1,2,1.2,1.1,1.4,1.2,1.3]
          this.setOption(categoryData,seriesData)
        }
      },
      setOption(categoryData,seriesData) {
        this.option = {
          backgroundColor: '#e6f7ff',
          title: {
              text: this.$t('24小时用量分析'),
              left: 'center',
              textStyle: {
                left: 'center',
                  fontWeight: 'normal',
                  fontSize: 16,
                  color: '#000000'
              }
          },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'shadow'
              }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [{
              type: 'category',
              data: categoryData,
              axisLine: {
                  lineStyle: {
                      color: 'rgba(255,255,255,0.12)'
                  }
              },
              axisLabel: {
                  margin: 10,
                  //color: '#e2e9ff',
                  textStyle: {
                      fontSize: 14
                  },
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: '#233e64'
                }
              },
          }],
          yAxis: [{
              splitNumber: 3,
              axisLabel: {
                  formatter: '{value}',
                  //color: '#e2e9ff',
              },
              axisLine: {
                  show: false
              },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#D4F2E7'
            }
          },
          }],
          series: [{
              type: 'bar',
              data: seriesData,
              name: 'm³',
              barMaxWidth: 14,
              itemStyle: {
                  normal: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                          offset: 0,
                          color: 'rgba(0,210,255,1)' // 0% 处的颜色
                      }, {
                          offset: 1,
                          color: 'rgba(58,123,213,1)' // 100% 处的颜色
                      }], false),
                      barBorderRadius: [30, 30, 30, 30],
                      shadowColor: 'rgba(0,160,221,1)',
                      //shadowBlur: 4,
                  }
              },
              markPoint: {
                    data: [
                        {type: 'max', name: this.$t('最大值')},
                        {type: 'min', name: this.$t('最小值')}
                    ]
                }
          },{
              type: 'line',
              data: seriesData,
              smooth: true,
              symbol: 'circle',
              animationDelay: 1000,
              itemStyle: {
                normal: {
                  color: '#F5A623',
                  borderColor: '#F5A623',
                  lineStyle: {
                    color: "#F5A623" //折线的颜色
                  }
                }
              },
          }]
      };
      }
    }
  }
</script>

<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
</style>